import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import bcrypt from 'bcryptjs'

function Copyright(props) {

  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>

    </Typography>
  );
}

// TODO remove, this demo shouldn't need to reset the theme.

const defaultTheme = createTheme();

export default function SignIn() {
  const navigate = useNavigate()

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    axios.post("https://gantasoft.in/dev/asvmall/userlogin.php", {
      main_id: "8989877hhftgh67",
      UserEmail: data.get('email'),
      UserPassword: bcrypt.hashSync(data.get('password'), '$2a$10$CwTycUXWue0Thq9StjUM0u'),
    }).then(
      (result) => {

        if (result.status == 200 && result.request.readyState == 4) {

          if (typeof result.data === "object" && Object.keys(result.data).length > 0) {
            localStorage.setItem("userid", result.data.UserID)
            navigate("/")
          } else {
            alert("please Enter valid Details")
            return
          }

        } else {
          alert("please Enter valid Details")
        }

      }
    ).catch(
      (err) => {
        console.log(err)

      }
    )
    // console.log({
    //   main_id:"8989877hhftgh67",
    //   UserEmail: data.get('email'),
    //   UserPassword:  bcrypt.hashSync(data.get('password'), '$2a$10$CwTycUXWue0Thq9StjUM0u')   ,
    // });
  };

  React.useEffect(
    () => {
      if (localStorage.getItem("userid")) {
        navigate("/Profiles")

      }

    }, []
  )

  const onForgotpasswordClick = () => {
    navigate("/forgotPassword")
  }

  const onregisterClick = () => {
    navigate("/register")
  }

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
            />
            <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember me"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}

            >
              Sign In
            </Button>
            <Grid container>
              <Grid item xs>
                <Link variant="body2" onClick={onForgotpasswordClick}>
                  Forgot password?
                </Link>
              </Grid>
              <Grid item>
                <Link onClick={onregisterClick} variant="body2">
                  {"Don't have an account? Sign Up"}
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
    </ThemeProvider>
  );
}